import { render, staticRenderFns } from "./NewFormButton.vue?vue&type=template&id=a2540a26&"
import script from "./NewFormButton.vue?vue&type=script&lang=js&"
export * from "./NewFormButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports